
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as closetBuZmNALy_45nHUhvn9qYnvciCV_Yg08YsMxmoJ5KFBhsMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/close.vue?macro=true";
import { default as error_e_X_45CgOYigPBoVeRpGK1b2VdUAEUPcAHgG5jQ5OaMcMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/error.vue?macro=true";
import { default as index9nzHmvvpHj2RINi2Jx3rlaWWNnH6HQqwRxlzGbuH_45k8Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/index.vue?macro=true";
import { default as editorfpFHPs3WNeCSA5LpesU_NLAXFK8F4NRN9gOwFkzG5z4Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/editor.vue?macro=true";
import { default as mywishWO0GS_45XrYcBIf0fYuo_XPdYsBUkQGG3c3y55xJO2ZrcMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/mywish.vue?macro=true";
import { default as previeweoj2ooHby_45szdcfLbTfAIYAxfJYJvQOmsrEyMcSrMjAMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/preview.vue?macro=true";
import { default as wishm4NOyIsYpdHLDhwd3QqB267l2pETGXY8pj80bRmixZQMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/v2/wish.vue?macro=true";
import { default as welcomeRm8CgKmudPqfmSQmWR33dmTTW_45K446_5p8mpIhbQOM4Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/welcome.vue?macro=true";
import { default as externalm7eDARrZuIhJq8tENJENEYpEPL_PeOK4kFfU7xl4EGcMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/external.vue?macro=true";
import { default as indexyItxxVO_0_cFnUi1Q_45b_i_DAZ3B0VXR4UJrpL7W8xWYMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/qr/index.vue?macro=true";
import { default as thankyouJuG_Ds9eGz3KBS8iwprmycHIi6yTJ1SFyQWu4asUE0YMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/thankyou.vue?macro=true";
import { default as indexBmHEyRa1pZ5zLKjfDzN7sVmukr4nvOpRgICeiF80RdUMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/v2/index.vue?macro=true";
import { default as loginEvent6ROmBTKd2ZtP_450NIXC2VA_45_arvmipW_45oW13vTm8RQdYMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/loginEvent.vue?macro=true";
import { default as editor_copyYN1fKNPP0oaxqJ1DFrCwNdoABkXaupynkeh_i9lR5oUMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/editor_copy.vue?macro=true";
import { default as indexyFQWcHMJAxMH8J8KsMSlcpt1BzF_LriQzBnoWjoUlA8Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/event/index.vue?macro=true";
import { default as maintenancexUPAepVuq3YI8hMLaMnoA7kszNi2ctkqBjTg8yhRZ6EMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/maintenance.vue?macro=true";
import { default as templateG1HrDxfQn54prGhOgsJlKzGAGEJANAyD3MIaA_45H5yDAMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/v2/template.vue?macro=true";
import { default as eventNotFoundbLiSqqF6sMOnDXOC0BpObmAg9AJQ7uy9lQ28yCUqdhUMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/eventNotFound.vue?macro=true";
import { default as _91qrcodeId_939hE67EITEhd2hL23JjRwc8hrr_oLyInrACk0bv8iSyMMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/qr/[qrcodeId].vue?macro=true";
import { default as qrcodeNotFoundDf3fVMH_v3YOWxu_X0U8wo35_45sL2C0eK7LYuNoYUszEMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/qrcodeNotFound.vue?macro=true";
import { default as selectTemplateM9nUxDPHGwKS7Gp8n_45TGnWkkPPa8_x6AFrjqoDvaoiYMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/selectTemplate.vue?macro=true";
import { default as _91eventId_93IZbguQINVImaLxiZ1I0xUZXfn8QKlbj2AQppK225S68Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/event/[eventId].vue?macro=true";
import { default as indexOXDZ9ul6DUt9FqRoXM0lJ4wGcVcKXVovunfhUqD_45gi0Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/promptpay/index.vue?macro=true";
import { default as wish_45cropper7QlRTdjBq9syt6iMApkAeNBKOBSaoPVDtsBQuTZkY_cMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/v2/wish-cropper.vue?macro=true";
import { default as attachghnTTjAG6nL1p_wcQd5GMOK4JqcfFBbS8NqIu58xmqEMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/promptpay/attach.vue?macro=true";
import { default as selectUploadAndWishXoNBP08NkpCSELqec_45GiI6rhahhYpwF4OkIJZ5ZWsAEMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/selectUploadAndWish.vue?macro=true";
import { default as test_45iframehOt5S3qbOCvdubFMJ0K3EY1TZH8SuA0QjzP8v2zJvL4Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/playground/test-iframe.vue?macro=true";
import { default as test_45wishesj0lVNl47076qgkaktMMZ8p_453mRsdXZCdiom75Oh7Gm0Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/playground/test-wishes.vue?macro=true";
import { default as test_45welcomeflidgfvwkgUSzIhhtXsxLt4T01VGSnQBeTAdp_45_eg_kMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/playground/test-welcome.vue?macro=true";
import { default as test_45template5cP7g5YMn1nByE7hMnSWvyyuDRVQXgLeFp3vPm3LX74Meta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/playground/test-template.vue?macro=true";
import { default as test_cover_image_welcomedaDT7mnvr5LaLmTGqJNDQJdzxyrsZhLrhYRlmGwoqxcMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/test_cover_image_welcome.vue?macro=true";
import { default as test_45wishes_45konvaPD4qsFUdhlWgAN5cDiqTogNfOSQpUZdMICH3nStYshwMeta } from "/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/playground/test-wishes-konva.vue?macro=true";
export default [
  {
    name: "close",
    path: "/close",
    meta: closetBuZmNALy_45nHUhvn9qYnvciCV_Yg08YsMxmoJ5KFBhsMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/close.vue")
  },
  {
    name: "error",
    path: "/error",
    meta: error_e_X_45CgOYigPBoVeRpGK1b2VdUAEUPcAHgG5jQ5OaMcMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/error.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/index.vue")
  },
  {
    name: "editor",
    path: "/editor",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/editor.vue")
  },
  {
    name: "mywish",
    path: "/mywish",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/mywish.vue")
  },
  {
    name: "preview",
    path: "/preview",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/preview.vue")
  },
  {
    name: "v2-wish",
    path: "/v2/wish",
    meta: wishm4NOyIsYpdHLDhwd3QqB267l2pETGXY8pj80bRmixZQMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/v2/wish.vue")
  },
  {
    name: "welcome",
    path: "/welcome",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/welcome.vue")
  },
  {
    name: "external",
    path: "/external",
    meta: externalm7eDARrZuIhJq8tENJENEYpEPL_PeOK4kFfU7xl4EGcMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/external.vue")
  },
  {
    name: "qr",
    path: "/qr",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/qr/index.vue")
  },
  {
    name: "thankyou",
    path: "/thankyou",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/thankyou.vue")
  },
  {
    name: "v2",
    path: "/v2",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/v2/index.vue")
  },
  {
    name: "loginEvent",
    path: "/loginEvent",
    meta: loginEvent6ROmBTKd2ZtP_450NIXC2VA_45_arvmipW_45oW13vTm8RQdYMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/loginEvent.vue")
  },
  {
    name: "editor_copy",
    path: "/editor_copy",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/editor_copy.vue")
  },
  {
    name: "event",
    path: "/event",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/event/index.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenancexUPAepVuq3YI8hMLaMnoA7kszNi2ctkqBjTg8yhRZ6EMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/maintenance.vue")
  },
  {
    name: "v2-template",
    path: "/v2/template",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/v2/template.vue")
  },
  {
    name: "eventNotFound",
    path: "/eventNotFound",
    meta: eventNotFoundbLiSqqF6sMOnDXOC0BpObmAg9AJQ7uy9lQ28yCUqdhUMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/eventNotFound.vue")
  },
  {
    name: "qr-qrcodeId",
    path: "/qr/:qrcodeId()",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/qr/[qrcodeId].vue")
  },
  {
    name: "qrcodeNotFound",
    path: "/qrcodeNotFound",
    meta: qrcodeNotFoundDf3fVMH_v3YOWxu_X0U8wo35_45sL2C0eK7LYuNoYUszEMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/qrcodeNotFound.vue")
  },
  {
    name: "selectTemplate",
    path: "/selectTemplate",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/selectTemplate.vue")
  },
  {
    name: "event-eventId",
    path: "/event/:eventId()",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/event/[eventId].vue")
  },
  {
    name: "promptpay",
    path: "/promptpay",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/promptpay/index.vue")
  },
  {
    name: "v2-wish-cropper",
    path: "/v2/wish-cropper",
    meta: wish_45cropper7QlRTdjBq9syt6iMApkAeNBKOBSaoPVDtsBQuTZkY_cMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/v2/wish-cropper.vue")
  },
  {
    name: "promptpay-attach",
    path: "/promptpay/attach",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/promptpay/attach.vue")
  },
  {
    name: "selectUploadAndWish",
    path: "/selectUploadAndWish",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/selectUploadAndWish.vue")
  },
  {
    name: "playground-test-iframe",
    path: "/playground/test-iframe",
    meta: test_45iframehOt5S3qbOCvdubFMJ0K3EY1TZH8SuA0QjzP8v2zJvL4Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/playground/test-iframe.vue")
  },
  {
    name: "playground-test-wishes",
    path: "/playground/test-wishes",
    meta: test_45wishesj0lVNl47076qgkaktMMZ8p_453mRsdXZCdiom75Oh7Gm0Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/playground/test-wishes.vue")
  },
  {
    name: "playground-test-welcome",
    path: "/playground/test-welcome",
    meta: test_45welcomeflidgfvwkgUSzIhhtXsxLt4T01VGSnQBeTAdp_45_eg_kMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/playground/test-welcome.vue")
  },
  {
    name: "playground-test-template",
    path: "/playground/test-template",
    meta: test_45template5cP7g5YMn1nByE7hMnSWvyyuDRVQXgLeFp3vPm3LX74Meta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/playground/test-template.vue")
  },
  {
    name: "test_cover_image_welcome",
    path: "/test_cover_image_welcome",
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/test_cover_image_welcome.vue")
  },
  {
    name: "playground-test-wishes-konva",
    path: "/playground/test-wishes-konva",
    meta: test_45wishes_45konvaPD4qsFUdhlWgAN5cDiqTogNfOSQpUZdMICH3nStYshwMeta || {},
    component: () => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-guest-v2/pages/playground/test-wishes-konva.vue")
  }
]